import LocalSettings from './LocalSettings';
const LOCAL_SETTINGS_KEY = 'EarlyRequestLogger';
export default class EarlyRequestLogger {
  constructor(key) {
    this.key = `${key}`;
    this.prefix = `[getFromEarlyRequest] ${Date.now()} ${this.key}`;
  }
  isEnabled() {
    return LocalSettings.get(LOCAL_SETTINGS_KEY);
  }
  start() {
    if (this.isEnabled()) {
      // eslint-disable-next-line no-console
      console.time(this.prefix);
    }
  }
  info(...props) {
    if (this.isEnabled()) {
      // eslint-disable-next-line no-console
      console.log(this.prefix, ...props);
    }
  }
  end(...props) {
    if (this.isEnabled()) {
      // eslint-disable-next-line no-console
      console.log(this.prefix, ...props);
      // eslint-disable-next-line no-console
      console.timeEnd(this.prefix);
    }
  }
}